import { Visibility, VisibilityOff } from '@mui/icons-material'
import { IconButton, InputAdornment, TextField } from '@mui/material'
import React from 'react'
import { Controller } from 'react-hook-form'

function PasswordForm({ control, errors, dynamicField, label, required, min, max }) {

  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  return (
    <>
      <Controller
        name={dynamicField}
        control={control}
        rules={{
          required: {
            value: required,
            message: `${label} is required`,
          },
          minLength: {
            value: min,
            message: `${label} must be at least ${min} characters`,
          },
          maxLength: {
            value: max,
            message: `${label} cannot exceed ${max} characters`,
          },
        }}
        render={({ field }) => (
          <TextField
            {...field}
            fullWidth
            label={label}
            type={showPassword ? 'text' : 'password'}
            size='small'
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleClickShowPassword}
                    sx={{ p: 0 }}
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            helperText={errors[dynamicField] && errors[dynamicField].message}
            error={Boolean(errors[dynamicField])}
          />
        )}
      />
    </>
  )
}

export default PasswordForm